import { render, staticRenderFns } from "./RFM_standard_analysis.vue?vue&type=template&id=c168ea1e&scoped=true"
import script from "./RFM_standard_analysis.vue?vue&type=script&lang=js"
export * from "./RFM_standard_analysis.vue?vue&type=script&lang=js"
import style0 from "./RFM_standard_analysis.vue?vue&type=style&index=0&id=c168ea1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c168ea1e",
  null
  
)

export default component.exports